"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSortOnHeaderClick = void 0;
const utilities_1 = require("./utilities");
function useSortOnHeaderClick(hooks) {
    hooks.getHeaderProps.push((headerProps, { column }) => {
        if (utilities_1.IsSortableColumn(column)) {
            return Object.assign(Object.assign({}, headerProps), column.getSortByToggleProps());
        }
        else {
            return headerProps;
        }
    });
}
exports.useSortOnHeaderClick = useSortOnHeaderClick;
//# sourceMappingURL=sort-on-header-click.js.map